import moment from 'moment';
import * as Common from "../../commons/common";

export class SearchCondition {
  updated_at_from: string = ""
  updated_at_to: string = ""
}

export interface QuestionnaireResult {
  student_code: string
  student_name: string
  lesson_code: string
  subject_name: string
  lesson_class_no: number
  lesson_name: string
  tantou_user_name: string
  understanding_level: number
  satisfaction_level: number
  comment: string
}